<template>
  <div>
    <div class="tabList">
      <div class="tabItem"
          v-for="(item, index) in tabList"
          @click="handleChange(index)"
        :class="{ active: activeName === index }"
        :key="'t' + index">{{item.label}}</div>
    </div>
    <div class="router-section">
      <Assets v-show="activeName === 0"></Assets>
      <Area v-show="activeName === 1"></Area>
      <Layer v-show="activeName === 2"></Layer>
      <!-- <component :is="com"></component> -->
    </div>
  </div>
</template>

<script>
import Area from './Area'
import Assets from './Assets'
import Layer from './Layer'
export default {
  name: 'Dialog',
  components: { Area, Assets, Layer },
  data () {
    return {
      tabList: [{
        label: '资产统计',
        name: '1',
        components: Assets
      }, {
        label: '区域分布',
        name: '2',
        components: Area
      }, {
        label: '图层管理',
        name: '3',
        components: Layer
      }],
      activeName: 0
    }
  },
  created () {
    // ...
  },
  computed: {
    com () {
      return this.tabList[this.activeName].components
    }
  },
  methods: {
    handleChange (val) {
      this.activeName = val
    }
  }
}
</script>

<style scoped lang='scss'>
.tabList {
  display: flex;
  width: 100%;
  height: 40px;
  background: #f5f5f5;
  overflow: auto;
  .tabItem {
    flex-shrink: 0;
    font-family: PingFang SC;
    font-size: 14px;
    height: 40px;
    color: #0D1550;
    padding: 12px 10px;
    cursor: pointer;
    &:not(:last-child) {
      margin-right: 20px;
    }
    &.active {
      position: relative;
      color: #0040FF;
      &::after {
        content: '';
        position: absolute;
        right: calc(50% - 7px);
        bottom: 0px;
        width: 14px;
        height: 2px;
        background: #3060FF;
        border-radius: 1px;
      }
    }
  }
}
.router-section {
    padding: 10px;
    background: #FFFFFF;
  }
</style>
